<div>
    <div class="head-list" id="distribution_list" *ngIf="showDistributionList">
        <div class="m-b-5">
            Distribution Lists
        </div>
        <div class="w-75">
            <ngx-select [items]="distributionLists"
                        [multiple]='true'
                        optionValueField= 'value'
                        optionTextField= 'text'
                        [(ngModel)]='selectedDistributionLists'
                        [keepSelectedItems]='true'
                        [searchCallback]='blankSearch'
                        [placeholder]='placeholdedrDistributionGroupSelect'
                        (typed)='onSearchTextTyped($event)'
                        (select)='onSelectDistributionGroup($event)'
                        (remove)='onRemoveDistributionGroup($event)'>
            </ngx-select>
        </div>
    </div>   
    <tabset>
        <tab *ngFor="let employeeSetting of selectedSettings;let i = index " heading="{{ 'Filter '+ (i+1) }}" id="tab1">
            <i (click)="removeFilterSet(employeeSetting)" class="fa fa-close"></i>
            <div class="head-list" id="business_unit_list">
                <div class="m-b-5 m-t-15">
                    Business unit
                </div>
                <app-drilldown *ngIf="businessUnitTreeView"
                               [defaultEntityId]="employeeSetting.selectedBusinessUnitId"
                               [treeviewEntities]="businessUnitTreeView"
                               [disableParentSelection]="true"
                               (onEntitySelected)="onBusinessUnitSelected($event, employeeSetting)">
                </app-drilldown>
            </div>
            <div class="head-list" id="respondents_grades_list">
                <div class="m-b-5">
                    Grades
                </div>
                <div>
                    <div class="w-50">
                        <app-multiple-dropdown *ngIf="employeeSetting.selectorGrades" displayText="Select grades" [items]="employeeSetting.selectorGrades" (itemChange)="onGradeChanged($event, employeeSetting)"></app-multiple-dropdown>
                    </div>
                </div>
            </div>
            <div class="head-list" id="position_list">
                <div class="m-b-5">
                    Positions
                </div>
                <div class="w-75">
                    <app-multiple-dropdown *ngIf="employeeSetting.selectorPositions" displayText="Select positions" [items]="employeeSetting.selectorPositions" (itemChange)="onPositionChanged($event, employeeSetting)"></app-multiple-dropdown>
                </div>
            </div>
            <div class="head-list" id="employee_list">
                <div class="m-b-5">
                    Employees
                </div>
                <div class="w-75">
                    <app-multiple-dropdown *ngIf="employeeSetting.selectorEmployees" displayText="Select employees" [items]="employeeSetting.selectorEmployees" (itemChange)="onEmployeeChanged($event, employeeSetting)"></app-multiple-dropdown>
                </div>
            </div>
        </tab>
    </tabset>
</div>
<div class="mt-2">
    <div class="d-flex align-items-center">
        <span (click)="addFilterSet()" class="add-btn" id="btn-add_bu">
        </span>
    </div>
</div>